import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Option } from '../../models/option.model';

@Component({
  standalone: false,
  selector: 'app-options-menu',
  templateUrl: './options-menu.component.html',
  styleUrls: ['./options-menu.component.scss'],
})
export class OptionsMenuComponent {
  @Input() options!: Option[];
  @Input() buttonIcon: string = 'more_horiz';
  @Input() buttonCvxIcon: string | undefined;
  @Input() exposeTriggerButton: boolean = false;
  @Input() hasUnresolvedFlags: boolean = false;

  @ViewChild('triggerButton', { static: true })
  triggerButtonRef!: ElementRef<HTMLButtonElement>;

  public get triggerButton(): HTMLButtonElement | null {
    return this.exposeTriggerButton
      ? this.triggerButtonRef?.nativeElement ?? null
      : null;
  }

  onOptionSelect(option: Option): void {
    option.onClick(option.data);
  }
}
